import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { NotFoundComponent } from './pages/other-pages/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [

  /* =======================
   * Admin CMS
   * ======================= */
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes')
        .then(c => c.ADMIN_ROUTES),
  },

  /* =======================
   * Website
   * ======================= */

  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: 'signup',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/signup/signup.component').then(c => c.SignupComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(c => c.DashboardComponent)
  },
  {
    path: 'invoice',
    canActivate: [authGuard],
    children: [
      { path: 'new', loadComponent: () => import('./pages/invoice/invoice-create.component').then(c => c.InvoiceCreatePageComponent) },
      { path: 'edit/:id', loadComponent: () => import('./pages/invoice/invoice-create.component').then(c => c.InvoiceCreatePageComponent) },
      { path: 'view/:id', loadComponent: () => import('./pages/invoice/invoice-view.component').then(c => c.InvoiceViewPageComponent) }
    ]
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/settings/settings.component').then(c => c.SettingsComponent),
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'profile', loadComponent: () => import('./pages/settings/profile/profile.component').then(c => c.ProfileComponent) },
      { path: 'companies', loadComponent: () => import('./pages/settings/companies-list/companies-list.component').then(c => c.CompaniesListComponent) },
      { path: 'clients', loadComponent: () => import('./pages/settings/clients-list/clients-list.component').then(c => c.ClientsListComponent) },
      { path: 'items', loadComponent: () => import('./pages/settings/items-list/items-list.component').then(c => c.ItemsListComponent) }
    ]
  },
  {
    path: 'website',
    loadChildren: () =>
      import('./website/website.routes')
        .then(c => c.WEBSITE_ROUTES),
  },

  /* =======================
   * 404
   * ======================= */
  {
    path: '**',
    component: NotFoundComponent,
  },

];



